import { ContactUs } from '@frx/frx-program-defaults';

export const Help = () => <ContactUs />;
